var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',{staticClass:"typing-title",style:({ width: `${ _vm.width }px` })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h1',{staticClass:"static-title",attrs:{"id":"staticTitle"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }